module.exports = __webpack_public_path__ + "img/cross_gray2.b68a9068.svg";